import { apiSlice } from '@/store/api/apiSlice';

export interface SheshaResponse {
  message: string;
}

export const sheshaApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getShesha: builder.query<SheshaResponse, string>({
      query: (userId) => ({
        url: '/astrology/shesha',
        method: 'GET',
        params: {
          userId,
        },
      }),
    }),
  }),
});

export const { useGetSheshaQuery } = sheshaApi;
